import { useEffect, useState } from 'react';
function useHideMainScreen({ openModal, setOpenModal }) {
  const [showMainScreen, setShowMainScreen] = useState(!openModal);

  const closeInfoScreen = () => {
    setOpenModal(false);
    setShowMainScreen(true);
  };

  useEffect(() => {
    if (openModal) setShowMainScreen(false);
  }, [openModal]);

  return {
    showMainScreen,
    closeInfoScreen,
  };
}

export default useHideMainScreen;

